<footer>
  <section class="mod-footer">
    <a class="sgt-footer-text footer-link" [innerHTML]="'WD-Help'" [href]="'/home'" (click)="handleClick($event)"></a>
    <a class="sgt-footer-text footer-link" [href]="homepageLink" (click)="handleClick($event)">{{ '© Siemens AG ' + currentYear }}</a>
    @for (item of footerLinks; track item) {
      <a class="sgt-footer-text footer-link" [href]="item.link" (click)="handleClick($event)">{{ item.name }}</a>
    }
  </section>
</footer>
